export default "__VITE_ASSET__BzkQ5DMF__"